import { render, staticRenderFns } from "./TripDetailTabChanges.vue?vue&type=template&id=67baf846&scoped=true&"
import script from "./TripDetailTabChanges.vue?vue&type=script&lang=ts&"
export * from "./TripDetailTabChanges.vue?vue&type=script&lang=ts&"
import style0 from "./TripDetailTabChanges.vue?vue&type=style&index=0&id=67baf846&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67baf846",
  null
  
)

export default component.exports